import { testimonials } from '@/mocks/testimonials';

export default function TestimonialsSection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            用户真实评价
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            百万彩民的信赖之选
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="bg-background-50 rounded-xl p-6 border border-background-200/70 hover:border-primary-200/70 transition-all duration-300"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-11 h-11 rounded-full object-cover"
                />
                <div>
                  <div className="font-medium text-foreground-950 text-sm">{t.name}</div>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-xs ${i < t.rating ? 'ri-star-fill text-primary-500' : 'ri-star-line text-foreground-300'}`}
                      ></i>
                    ))}
                  </div>
                </div>
                <span className="ml-auto text-xs text-foreground-400">{t.lotteryType}</span>
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed">{t.content}</p>
              <div className="mt-3 text-xs text-foreground-400">{t.date}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}